import { datadogLogs } from '@datadog/browser-logs';

type LogContext = Record<string, unknown>;

const isLocalhost = window.location.hostname === 'localhost';

export const initMonitoring = (): void => {
    if (isLocalhost) {
        return;
    }

    datadogLogs.init({
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        env: import.meta.env.VITE_ENV,
        service: 'portal-fe',
        version: import.meta.env.VITE_GIT_COMMIT_HASH || 'unknown',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error'],
        sessionSampleRate: 100,
        // Failed requests are already logged with rich context by the RTK error
        // handler (origin 'logger'); drop the SDK's bare network-error duplicate.
        beforeSend: (log) => log.origin !== 'network',
    });
};

export const logError = (error: unknown, context?: LogContext): void => {
    const normalizedError = error instanceof Error ? error : new Error(String(error));
    datadogLogs.logger.error(normalizedError.message, context, normalizedError);
};

export const logMessage = (message: string, context?: LogContext): void => {
    datadogLogs.logger.error(message, context);
};

export const logInfo = (message: string, context?: LogContext): void => {
    datadogLogs.logger.info(message, context);
};

export const setUser = (user: { id: string; email?: string } | null): void => {
    if (user) {
        datadogLogs.setUser(user);
    } else {
        datadogLogs.clearUser();
    }
};
